import { useState } from "react";
import useStableCallback from "src/hooks/useCallbackUtils/useStableCallback";
import { ebGlobalChannel } from "src/lib/events-bridge";
import useSubscription from "src/lib/events-bridge/hooks/useSubscription";
import EBAPIs from "src/lib/events-bridge/topics";
const getInitialState = () => ({
    isVisible: false,
    src: '',
});
export function usePDFViewer() {
    const [state, setState] = useState(() => getInitialState());
    const show = useStableCallback((data) => {
        setState({
            ...data,
            isVisible: true,
        });
    });
    const hide = useStableCallback(() => {
        setState(getInitialState());
    });
    useSubscription(EBAPIs.helperViews.pdfViewer.show, show);
    const actions = {
        show,
        hide,
    };
    return [state, actions];
}
export const pdfViewHelperActions = {
    show(data) {
        ebGlobalChannel.publish(EBAPIs.helperViews.pdfViewer.show, data);
    },
    // hide() {
    //   ebGlobalChannel.publish(EBAPIs.helperViews.pdfViewer.hide);
    // },
};
